<template>
  <b-card :id="id" :ref="id">
    <div class="d-flex justify-content-between">
      <h4 class="mb-0 text-primary font-weight-bold">
        <slot name="title">{{title}}</slot>
      </h4>
    </div>
    <b-collapse
      :id="`${id}-collapse`"
      :visible="!value"
      class="mt-3"
      @hide="onHide">
      <slot></slot>
    </b-collapse>
    <hr v-if="collapsible && !value" class="border-dark" />
      <div
        v-if="collapsible"
        class="collapse-ack d-inline-flex align-items-center">

        <b-form-checkbox
          :id="`${title}-collapse-check`"
          :disabled="mfsUser || mfsAdmin || isNonNotifierLandowner"
          :checked="checked"
          @input="input"
          inline
          class="label-before"
        >
          <span class="mr-2 text-secondary font-md mb-0 mr-3">
            <template v-if="value">
              {{ acknowledgement ? 'Acknowledged' : 'Certified' }}
            </template>
            <template v-else>
              <template v-if="acknowledgement">
                I acknowledge <b>{{ contextText }}</b> information.
              </template>
              <template v-else-if="isNonNotifierLandowner">
                Certified by Designated Agent
              </template>
              <template v-else>
                I certify that <b>{{ contextText }}</b> information is correct
              </template>
            </template>
          </span>
        </b-form-checkbox>

      </div>
  </b-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'SummaryCard',
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    scrollToId: {
      type: String,
      required: false,
    },
    value: {
      type: Boolean,
      required: true,
    },
    collapsible: {
      type: Boolean,
      default: true,
    },
    acknowledgement: {
      type: Boolean,
      default: false,
    },
    context: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapState('Notification', {
      landownerUser: state => state.notification.landownerUser,
    }),
    ...mapState('User', {
      userId: state => state.user.id,
    }),
    ...mapGetters('Notification', ['isBeingCertifiedByDA']),
    ...mapGetters('User', ['mfsUser', 'mfsAdmin']),
    isNonNotifierLandowner() {
      return this.landownerUser
        && this.landownerUser.id === this.userId
        && this.isBeingCertifiedByDA;
    },
    checked() {
      return this.isNonNotifierLandowner || this.value;
    },
    contextText() {
      return this.context ? `the ${this.context}` : 'this';
    },
  },
  methods: {
    input(value) {
      this.$emit('input', value);
    },
    onHide() {
      if (this.scrollToId) {
        this.$scrollTo(`#${this.scrollToId}-collapse`,
          500, {
            container: document.querySelector('.wizard-tab-content'),
            offset: -100,
          });
      }
    },
  },
};
</script>
